import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

// We no longer have Font Awesome Pro, so free icons are registered under the
// Pro prefixes (fal/far/fas) and Pro icon names that the code and the database
// (question option / button icons) still refer to, e.g. ['far', 'shield-check'].

// Pro-only icon name => closest free solid icon
const PRO_ONLY_FALLBACKS = {
    'analytics': 'chart-bar',
    'arrow-alt-to-right': 'arrow-right',
    'badge-check': 'check-circle',
    'badge-percent': 'percentage',
    'chart-network': 'project-diagram',
    'chart-pie-alt': 'chart-pie',
    'clipboard-list-check': 'clipboard-check',
    'cloud-upload': 'cloud-upload-alt',
    'file-chart-line': 'file-alt',
    'file-spreadsheet': 'file-excel',
    'heart-rate': 'heartbeat',
    'level-up': 'level-up-alt',
    'pallet-alt': 'pallet',
    'pencil': 'pencil-alt',
    'poll-people': 'poll',
    'shield-check': 'shield-alt',
    'sign-out': 'sign-out-alt',
    'smile-plus': 'smile',
    'spinner-third': 'circle-notch',
    'stars': 'star',
    'user-chart': 'chalkboard-teacher',
    'user-headset': 'headset',
}

export const asIcon = (icon, prefix, iconName = icon.iconName) => ({ ...icon, prefix, iconName })

const byName = (pack) => Object.values(pack).reduce((icons, icon) => ({ ...icons, [icon.iconName]: icon }), {})

const solidByName = byName(fas)
const regularByName = byName(far)

// Every free icon (plus the Pro-only fallbacks) under the given prefix. Light and
// regular prefixes prefer the outlined free regular icon where one exists.
export const freeIconPack = (prefix) => {
    const icons = prefix === 'fas' ? solidByName : { ...solidByName, ...regularByName }
    const pack = {}

    Object.entries(icons).forEach(([iconName, icon]) => {
        pack[iconName] = asIcon(icon, prefix, iconName)
    })
    Object.entries(PRO_ONLY_FALLBACKS).forEach(([proName, freeName]) => {
        pack[proName] = asIcon(solidByName[freeName], prefix, proName)
    })

    return pack
}
